import { render, staticRenderFns } from "./SubscriptionPricingTable.vue?vue&type=template&id=3f89c0ea"
import script from "./SubscriptionPricingTable.vue?vue&type=script&lang=js"
export * from "./SubscriptionPricingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports